module.exports = __webpack_public_path__ + "assets/devices/Next-CAM-PG2-c3981afae6b67a043c719b27e0c622f3.svg";